import styled from 'styled-components'

const InnerContent = styled.div`
  user-select: none;
  padding: 20px;
  background-color: #F8FAFC;
  box-shadow: inset 0px 11px 8px -10px #cbd6db;
  border: 1px solid #B9C5CD;
  border-top: none;
  border-radius: 0 0 6px 6px;
`

InnerContent.displayName = 'InnerContent'

export default InnerContent
